import { gql } from '@apollo/client';

export const ORDER_TABLE_PROFILE_FIELDS = gql`
    fragment OrderTableProfileFields on order_table_profiles {
        order_table_profile_id
        user_id
        table_type
        name
        settings
        created_at
        last_modified_at
    }
`;
